import { DriverRole, DriverSelectionType } from '../enums/driver-deviation-enums';

export class DriverInfo {
  constructor(
    public firstName: string,
    public lastName: string,
    public role: DriverRole,
    public route: {
      origin: string;
      destination: string;
      departureAtUtc: Date;
      arrivalAtUtc: Date;
    },
    public id?: string,
    public userId?: string,
    public employeeId?: string,
    public phoneNumber?: string,
    public selection?: DriverSelectionType,
    public isSelected?: boolean
  ) {}
}
